import React, { useRef, useState } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import Button from "../button";
import Modal from "../modal";
import "./imageCropper.scss";
import "react-image-crop/src/ReactCrop.scss";

const MAX_OUTPUT_SIZE = 360; // px

const buildCenteredCrop = (mediaWidth, mediaHeight, aspect) => {
    return centerCrop(
        makeAspectCrop(
            {
                unit: "px",
                width: 150,
            },
            aspect,
            mediaWidth,
            mediaHeight
        ),
        mediaWidth,
        mediaHeight
    );
};

const ImageCropper = ({
    fullImageSrc,
    isOpen,
    toggleModal,
    uploadCroppedImage,
}) => {
    const imgRef = useRef();
    const [cropConfigData, setCropConfig] = useState(null);

    const applyCenterCrop = () => {
        if (imgRef.current) {
            const { width, height } = imgRef.current;
            setCropConfig(buildCenteredCrop(width, height, 1));
        }
    };

    function getCroppedImage() {
        if (!imgRef.current || !cropConfigData) return null;

        const canvas = document.createElement("canvas");
        const { naturalWidth, naturalHeight, width, height } = imgRef.current;
        const scaleX = naturalWidth / width;
        const scaleY = naturalHeight / height;

        // Crop region
        const naturalCropWidth = Math.round(cropConfigData.width * scaleX);
        const naturalCropHeight = Math.round(cropConfigData.height * scaleY);

        const outputScale = Math.min(1, MAX_OUTPUT_SIZE / Math.max(naturalCropWidth, naturalCropHeight));
        canvas.width = Math.round(naturalCropWidth * outputScale);
        canvas.height = Math.round(naturalCropHeight * outputScale);

        const ctx = canvas.getContext("2d");
        ctx.imageSmoothingQuality = "high";
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.drawImage(
            imgRef.current,
            cropConfigData.x * scaleX,
            cropConfigData.y * scaleY,
            naturalCropWidth,
            naturalCropHeight,
            0,
            0,
            canvas.width,
            canvas.height
        );

        return canvas.toDataURL("image/png");
    }

    const saveCropped = () => {
        const imgData = getCroppedImage();
        uploadCroppedImage(imgData);
    };

    return (
        <>
            <Modal
                isOpen={isOpen}
                size="medium"
                hideCloseButton={true}
                toggleModal={toggleModal}
                title={
                    <div>
                        <div className="font18Black boldFont">Crop Photo</div>
                        <div className="font12Grey fontNormal noWrap">
                            Click and drag the box to crop the photo
                        </div>
                    </div>
                }
                disableBackdropToggle={true}
                containerClass={"cropperModal"}
            >
                <form>
                    <div className="cropperContentWrapper mt-5">
                        {fullImageSrc && (
                            <ReactCrop
                                crop={cropConfigData}
                                onChange={(cropConfig) =>
                                    setCropConfig(cropConfig)
                                }
                                aspect={1}
                                minHeight={40}
                                keepSelection={true}
                            >
                                <img
                                    src={fullImageSrc}
                                    ref={imgRef}
                                    className="cropperImage"
                                    onLoad={applyCenterCrop}
                                    alt="cropper"
                                />
                            </ReactCrop>
                        )}
                    </div>
                    <div className="croppermodalButtonHolder">
                        <div className="border-top" />
                        <div className="text-center mt-4 mb-0 float-bottom">
                            <Button
                                label="Cancel"
                                onClick={toggleModal}
                                className="btn-light mx-2 cancelButtonDelete"
                            />
                            <Button
                                label="Crop & Save"
                                type="button"
                                className="btn-blue mx-2"
                                onClick={saveCropped}
                            />
                        </div>
                    </div>
                </form>
            </Modal>
        </>
    );
};
export default ImageCropper;
